"use strict";

(function ($) {

    $(document).ready(function () {
        const $progressBarContainer = $("#progress-container");
        const $progressBar = $("#progress-bar");
        $(window).on("scroll", function () {
            const scroll = $(document).scrollTop();
            const totalHeight = $(document).height() - $(window).height();
            const progress = (scroll / totalHeight) * 100;
            $progressBar.css("width", progress + "%");
            if (scroll > 50) {
                $progressBarContainer.addClass('active');
            } else {
                $progressBarContainer.removeClass('active');
            }
        });
    });

    $(document).on('click', 'a[href^=\\#]', function (e) {
        let el = $($(this).attr('href'));
        if (el.length && el.offset()) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: el.offset().top - $('header').height()
            }, 500);
        }
    });

    $('button.burger').on('click', function () {
        $('body').toggleClass('overflow-hidden');
        $('.header-nav').toggleClass('active');
        $(this).toggleClass('burger-active');
    });

    $(document).on('click', '.header .genesis-nav-menu > ul > .menu-item-type-custom:not(.open)', function () {
        if ($('.header').hasClass('header-mobile')) {
            $(this).addClass('open').children().last().slideDown(150);
        }
    });
    $(document).on('click', '.header .genesis-nav-menu > ul > .menu-item-type-custom.open', function () {
        if ($('.header').hasClass('header-mobile')) {
            $(this).removeClass('open').children().last().slideUp(150);
        }
    });

    // Header Scripts
    document.addEventListener('DOMContentLoaded', function () {
        const header = document.querySelector('header.header');
        if (!header) return;

        let lastScrollTop = 0;
        let ticking = false;

        function onScroll() {
            const st = window.pageYOffset || document.documentElement.scrollTop;

            // header-active
            if (st > 0) {
                header.classList.add('header-active');
            } else {
                header.classList.remove('header-active');
            }

            // header-scroll
            if (st > 300) {
                if (st > lastScrollTop) {
                    header.classList.add('header-scroll');
                } else {
                    header.classList.remove('header-scroll');
                }
            } else {
                header.classList.remove('header-scroll');
            }

            lastScrollTop = st <= 0 ? 0 : st; // захист від iOS bounce
            ticking = false;
        }

        window.addEventListener('scroll', function () {
            if (!ticking) {
                window.requestAnimationFrame(onScroll);
                ticking = true;
            }
        }, { passive: true });
    });

    jQuery(document).ready(function ($) {
        if ($('.kitchens-company-other-wrap').hasClass('icons')) {
            var $items = $('.kitchens-company-other-box');
            $('.kitchens-company-other-list').html(`
            <div class="kitchens-company-col col-left"></div>
            <div class="kitchens-company-col col-right"></div>
        `);
            var doWrapHTML = `
            <div class="do">
                <span>do</span>
            </div>
        `;
            var dontWrapHTML = `
            <div class="do">
                <span>don't</span>
            </div>
        `;
            $('.col-left').prepend(doWrapHTML);
            $('.col-right').prepend(dontWrapHTML);
            $items.each(function (index) {
                if (index % 2 === 0) {
                    $('.col-left').append($(this));
                } else {
                    $('.col-right').append($(this));
                }
            });
        }
    });

    class BeforeAfterSlider {
        constructor(element) {
            this.$slider = $(element);
            this.$before = this.$slider.find('.before-image');
            this.$beforeImage = this.$before.find('img').first();
            this.$resizer = this.$slider.find('.resizer');
            this.active = false;
            this.init();
        }
        init() {
            if (this.$before.length === 0 || this.$beforeImage.length === 0 || this.$resizer.length === 0) {
                return;
            }
            this.initSliderWidth();
            this.bindEvents();
        }
        initSliderWidth() {
            const width = this.$slider.outerWidth();
            this.$beforeImage.css('width', width + 'px');
        }
        bindEvents() {
            $(window).on('resize', () => this.initSliderWidth());
            this.$resizer.on('mousedown', (e) => this.onResizerMouseDown(e));
            $(document).on(`mouseup.${this.getNamespace()}`, () => this.onDocumentMouseUp());
            $(document).on(`mousemove.${this.getNamespace()}`, (e) => this.onDocumentMouseMove(e));
            this.$resizer.on('touchstart', (e) => this.onResizerTouchStart(e));
            $(document).on(`touchend.${this.getNamespace()}`, () => this.onDocumentTouchEnd());
            $(document).on(`touchmove.${this.getNamespace()}`, (e) => this.onDocumentTouchMove(e));
        }
        onResizerMouseDown(e) {
            this.active = true;
            this.$resizer.addClass('resize');
            e.stopPropagation();
        }
        onDocumentMouseUp() {
            this.active = false;
            this.$resizer.removeClass('resize');
        }
        onDocumentMouseMove(e) {
            if (!this.active) return;
            let x = e.pageX - this.$slider.offset().left;
            this.slideIt(x);
            this.pauseEvent(e);
        }
        onResizerTouchStart(e) {
            this.active = true;
            this.$resizer.addClass('resize');
            e.stopPropagation();
        }
        onDocumentTouchEnd() {
            this.active = false;
            this.$resizer.removeClass('resize');
        }
        onDocumentTouchMove(e) {
            if (!this.active) return;
            const touch = e.originalEvent.touches[0];
            let x = touch.pageX - this.$slider.offset().left;
            this.slideIt(x);
            this.pauseEvent(e);
        }
        slideIt(x) {
            const transform = Math.max(0, Math.min(x, this.$slider.outerWidth()));
            this.$before.css('width', transform + "px");
            this.$resizer.css('left', transform + "px");
        }
        pauseEvent(e) {
            e.stopPropagation();
            e.preventDefault();
            return false;
        }
        getNamespace() {
            return `beforeAfter${this.$slider.index()}`;
        }
        destroy() {
            $(document).off(`.${this.getNamespace()}`);
            $(window).off('resize');
        }
    }

    $(document).ready(function () {
        $('.before-after-slider').each(function () {
            new BeforeAfterSlider(this);
        });
    });

    $('.social-share span').on('click', function () {
        let link = $(this).data('link');
        let url = $(this).data('url');
        let fullUrl = 'https://' + link + url;
        window.open(fullUrl, '_blank');
    });

    (() => {

        const updateStickyTableOffsets = () => {
            document.querySelectorAll('.sticky-table').forEach(table => {

                const firstCell = table.querySelector('tr td:nth-child(1), tr th:nth-child(1)');
                if (!firstCell) return;

                const leftOffset = firstCell.getBoundingClientRect().width - 3;

                table.querySelectorAll('td:nth-child(2), th:nth-child(2)').forEach(cell => {
                    cell.style.left = `${leftOffset}px`;
                });
            });
        };

        // первинний запуск
        const run = () => requestAnimationFrame(updateStickyTableOffsets);

        document.addEventListener('DOMContentLoaded', run);
        window.addEventListener('resize', run);
        window.addEventListener('orientationchange', run);

    })();


    document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('body.single h2').forEach(el => {

            // ❗ Пропускаємо, якщо є будь-які HTML-елементи всередині
            if (el.children.length > 0) {
                return;
            }

            const text = el.textContent.trim();
            if (!text) return;

            const words = text.split(/\s+/);
            const count = words.length;

            // 1 слово — все 700
            if (count === 1) {
                el.textContent = words[0];
                return;
            }

            // 2 або 3 слова — останнє 600
            if (count === 2 || count === 3) {
                const normal = words.slice(0, -1).join(' ');
                const light = words.slice(-1).join(' ');

                el.innerHTML = `<span class="fw-700">${normal}</span> ${light}`;
                return;
            }

            // 4+ слів — останні 2 слова 600
            const normal = words.slice(0, -2).join(' ');
            const light = words.slice(-2).join(' ');

            el.innerHTML = `<span class="fw-700">${normal}</span> ${light}`;
        });
    });


    // Form Selects (Safari compatible)
    jQuery(document).ready(function ($) {

        $('form').each(function () {
            const $form = $(this);

            const $service = $form.find('select[name="cases-service"]');
            const $budget = $form.find('select[name="cases-budget"]');

            if (!$service.length || !$budget.length) return;

            // Зберігаємо "оригінальні" опції бюджету для конкретної форми
            if (!$budget.data('originalOptions')) {
                const original = [];
                $budget.find('option').each(function () {
                    const $opt = $(this);
                    original.push({
                        value: $opt.attr('value') ?? '',
                        text: $opt.text(),
                        // важливо: зберігаємо selected/disabled якщо були у розмітці
                        selected: $opt.is(':selected'),
                        disabled: $opt.is(':disabled')
                    });
                });
                $budget.data('originalOptions', original);
            }

            function rebuildBudgetOptions(allowedValuesSet) {
                const original = $budget.data('originalOptions') || [];
                const currentVal = $budget.val();

                // Перебудовуємо список опцій (Safari-friendly)
                $budget.empty();

                original.forEach(function (o) {
                    // Плейсхолдер/порожній value завжди лишаємо
                    const isPlaceholder = (o.value === '' || o.value === null);

                    if (!isPlaceholder && allowedValuesSet && !allowedValuesSet.has(o.value)) {
                        return; // опцію прибираємо
                    }

                    const opt = new Option(o.text, o.value, false, false);
                    if (o.disabled) opt.disabled = true;
                    $budget.append(opt);
                });

                // Повертаємо вибір, якщо він досі існує; інакше — скидаємо
                if (currentVal && $budget.find('option[value="' + CSS.escape(currentVal) + '"]').length) {
                    $budget.val(currentVal);
                } else {
                    $budget.val('');
                }
            }

            function applyRules() {
                const val = $service.val();

                // null/undefined => без фільтра (залишити всі)
                let disallow = [];

                if (val === 'Bathroom Renovation') {
                    disallow = ['$10,000 - $20,000'];
                } else if (val === 'Kitchen Renovation' || val === 'Home Renovation') {
                    disallow = ['$10,000 - $20,000', '$20,000 - $30,000'];
                }

                // Створюємо allowed set із оригінальних опцій, виключаючи disallow
                const original = $budget.data('originalOptions') || [];
                const allowed = new Set(
                    original
                        .map(o => o.value ?? '')
                        .filter(v => v === '' || !disallow.includes(v))
                );

                rebuildBudgetOptions(allowed);
            }

            $service.on('change', applyRules);

            // Ініціалізація для цієї форми
            applyRules();
        });

    });

    // Modal Form
    document.addEventListener("click", function (e) {
        if (e.target.closest(".popup")) {
            e.preventDefault();
            const form = document.querySelector(".popup-bg");
            if (form) {
                form.classList.add("show-popup");
                form.style.display = "flex";
            }
        }

        if (
            e.target.closest(".close-popup") ||
            e.target.classList.contains("popup-bg")
        ) {
            const form = document.querySelector(".popup-bg");
            if (form) {
                form.classList.remove("show-popup");
                form.style.display = "none";
            }
        }
    });

    jQuery(document).ready(function ($) {
        if ($('body').hasClass('page-template-default')) {
            $('.content-sidebar-wrap').attr('id', 'scroll-widget');
        }
    });

    jQuery(function ($) {
        $(".input-field")
            .on("input", function () {
                $(this)
                    .closest(".input-wrapper")
                    .find(".field-label")
                    .toggleClass("has-value", $(this).val().trim() !== "");
            })
            .trigger("input");
    });

})(jQuery);